export default [{
  path: '/question-direction-list',
  name: 'questionDirectionList',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/quiz/questionDirectionList/index')
}]
